const e = {
  color: {
    bullet: "#c8d3deff",
    bulletCurrent: "#47c47dff",
    bulletProgress: "#b9edbdff"
  }
};
export {
  e as dotStepper
};
